import * as types from './types';

const initialState = {
  theme: 'DEFAULT',
  captureFlow: null,
  captureFlowData: [],
  captureFlowScreen: [],
  captureSkipData: [],
  captureSkippable: false,
  continuously: false,
  queryString: '',
  userCustom: null,
  userForm: false,
  cageBranding: null,
  cageOutline: null,
  qrScanner: false,
  useCase: '',
  contactSupport: false,
  currentStage: null,
};

const themeReducer = (state = initialState, action) => {
  const payload = action.payload;
  switch (action.type) {
    case types.GET_THEME: {
      return {
        ...state,
        theme: payload.data,
      };
    }
    case types.SET_CAPTURE_FLOW: {
      return {
        ...state,
        captureFlow: payload.flow,
        captureFlowData: payload.flowData || [],
        captureFlowScreen: payload.flowScreen || [],
        captureSkippable: payload.isSkippable || false,
      };
    }
    case types.SET_CAPTURE_SKIP: {
      return {
        ...state,
        captureSkipData: payload,
      };
    }
    case types.GET_FLOW: {
      return {
        ...state,
        continuously: true,
      };
    }
    case types.QUERY_URL: {
      return {
        ...state,
        queryString: payload.data,
      };
    }
    case types.USER_CUSTOM: {
      const fieldsToUpdate = [
        'theme',
        'userForm', 
        'cageBranding',
        'cageOutline',
        'urlRedirect',
        'qrScanner',
        'useCase',
        'contactSupport',
        'dynamicCapture',
        'dynamicCaptureEnforce'
      ];

      return {
        ...state,
        ...fieldsToUpdate.reduce((updates, field) => {
          if (payload[field] !== null) {
            updates[field === 'theme' ? 'userCustom' : field] = payload[field];
          }
          return updates;
        }, {})
      };
    }

    case types.SET_THEME: {
      return {
        ...state,
        theme: payload.data,
      };
    }
    case types.SET_PHOTO_DISPUTE: {
      return {
        ...state,
        disputePhotos: payload.data,
      };
    }
    case types.CLEAR_THEME:
      return initialState;
    case types.SET_CURRENT_STAGE:
      return {
        ...state,
        currentStage: payload,
      };
    default:
      return state;
  }
};
export default themeReducer;
